import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'

type InputProps = InputHTMLAttributes<HTMLInputElement>

const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ className = '', ...rest }, ref) {
  return (
    <input
      ref={ref}
      className={`wb-input min-h-[46px] w-full rounded-xl border border-text-2/20 px-3.5 py-3 text-text placeholder:text-text-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold focus-visible:outline-offset-2 ${className}`}
      {...rest}
    />
  )
})

export default Input
